/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Loading from '../../components/Loading';

import * as giftcardService from '../../services/giftcards';

import stylesLayout from '../../common/layout.module.scss';
import GiftcardsTable from '../../components/GiftcardsTable';

const GiftcardsModule = (
) => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [giftcards, setGiftcards] = useState([]);

  const loadGiftcards = async () => {
    setLoading(true);
    const rsp = await giftcardService.all();
    if (rsp && rsp.status) {
      setGiftcards(rsp.data);
    }
    setLoading(false);
  };

  const onAction = (action, hash) => {
    switch (action) {
      case 'view':
        history.push(`/giftcard/${hash}`);
        break;
      default:
    }
  };

  useEffect(() => {
    loadGiftcards();
  }, []);

  if (loading) {
    return <div className={stylesLayout.page}><Loading /></div>;
  }

  // const stepsStore = getStepsStore(store);
  // const pendingStepsStore = (stepsStore.filter((x) => !x.completed));
  return (
    <div className={stylesLayout.page}>
      <div className={stylesLayout.title}>
        Giftcards
        <div className={stylesLayout.secAction}>
          <Button onClick={() => { history.push('/giftcard/nueva'); }}>
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: 10 }} />
            Agregar
          </Button>
        </div>
      </div>
      <div className={stylesLayout.content}>
        <GiftcardsTable
          items={giftcards}
          onAction={onAction}
        />
      </div>
    </div>
  );
};

GiftcardsModule.propTypes = {
};

export default GiftcardsModule;
